export const config = {
  baseUrl: '',
  siteName: 'CloutPunch',
  baseMailUrl: 'https://mailer.muvon.dev',
}
